(function () {
  'use strict';

  // ============================================================
  // BRAND CONFIG — the values most likely to change per brand.
  // Jockey NZ: facts per jockey.co.nz's own shipping policy copy —
  // standard shipping is free for Jockey members; non-members get it
  // free over $49 (excluding eGift Cards) or pay $10 under that;
  // delivery usually takes 3-5 business days. Confirmed 2026-09-18.
  // ============================================================
  const BRAND = {
    fontBody: '"Nunito Sans", sans-serif',
    fontHeading: '"Montserrat", sans-serif',
    fontWeightHeading: '400',
    colorText: '#001135',
    colorBorder: '#e2e4e8',
    colorBg: '#f5f5f5',
    accent: '#001135', // used only where a distinct accent reads better than colorText (none currently)
    radius: '0px', // fact-strip / rate-block corner radius
    headingTextTransform: 'none',
    headingLetterSpacing: '0',
    freeShippingThreshold: '$49',
  };

  // Icons: simple stroke line-icons, currentColor so they always match the theme.
  const ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 7h13v9H1z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="5.5" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 7"/></svg>'
  };

  const CONTENT_MARKUP = `
    <div class="jk-ship">

      <h1 class="jk-title">Shipping</h1>

      <div class="jk-dispatch-callout" role="note">
        <strong>Next business day dispatch from Auckland*</strong>
        <span>In-stock orders are dispatched from our Auckland warehouse on the next business day.</span>
        <small>*Order cut-off times, weekends, public holidays and product availability exclusions apply.</small>
      </div>

      <ul class="jk-facts">
        <li>${ICONS.check}<div><strong>Free for members</strong><span>or on orders over ${BRAND.freeShippingThreshold}</span></div></li>
        <li>${ICONS.truck}<div><strong>3-5 day delivery</strong><span>Via New Zealand Post</span><span>(Need it faster? Express available))</span></div></li>
        <li>${ICONS.pin}<div><strong>Tracked, door to door</strong><span>Emailed the moment it ships</span></div></li>
      </ul>

      <div class="jk-cols">
        <div class="jk-col">
          <h2>New Zealand</h2>
          <table class="jk-rates">
            <thead><tr><th scope="col">Service</th><th scope="col">Delivery time</th><th scope="col">Cost</th></tr></thead>
            <tbody>
              <tr><td>Standard</td><td>3-5 business days</td><td>$10 (free for members, or over ${BRAND.freeShippingThreshold})</td></tr>
              <tr><td>Express</td><td>Next business day (Express Post network)</td><td>$15</td></tr>
            </tbody>
          </table>
          <p class="jk-note">Sent via New Zealand Post or a courier, depending on your location. eGift Cards don't require shipping.</p>
        </div>

        <div class="jk-col">
          <h2>International</h2>
          <p class="jk-lead">Shown at checkout once you enter your address - added to your total before you pay.</p>
          <p class="jk-note">Rates exclude any overseas duties and customs charges, which are the recipient's responsibility.</p>
        </div>
      </div>

      <div class="jk-faq">
        <details>
          <summary>Where's my order?</summary>
          <p>We'll email your New Zealand Post tracking number as soon as your order leaves our warehouse. New tracking numbers can take up to 4 hours to become searchable &mdash; that's normal.</p>
        </details>
        <details>
          <summary>What about customs, duties and taxes?</summary>
          <p>Your order is charged in NZD, excluding GST. International orders may attract duties, taxes or local charges on arrival &mdash; these are the recipient's responsibility. We can't mark orders as gifts to reduce fees, and orders over your country's formal-entry threshold may incur an additional customs clearance fee from our logistics partner. Check with your local customs office before you order.</p>
        </details>
      </div>

    </div>
  `;

  const CONTENT_CSS = `
    .jk-ship{
      max-width: 1360px;
      margin: 0 auto;
      padding: clamp(1.5rem, 4vw, 3.5rem) clamp(1rem, 4vw, 2.5rem) clamp(3rem, 6vw, 5rem);
      font-size: 1.05rem;
      font-family: ${BRAND.fontBody};
      color: ${BRAND.colorText};
    }
    .jk-ship, .jk-ship *{ box-sizing: border-box; }

    .jk-title{
      margin: 0 0 clamp(1.25rem, 3vw, 2rem);
      font-size: clamp(1.8rem, 3.4vw, 2.6rem);
      font-family: ${BRAND.fontHeading};
      font-weight: ${BRAND.fontWeightHeading};
      text-transform: ${BRAND.headingTextTransform};
      letter-spacing: ${BRAND.headingLetterSpacing};
    }

    .jk-dispatch-callout{
      display: flex;
      flex-direction: column;
      gap: .25rem;
      margin: 0 0 clamp(1.5rem, 4vw, 2.5rem);
      padding: 1rem 1.25rem;
      border-left: 4px solid ${BRAND.accent};
      background: ${BRAND.colorBg};
    }
    .jk-dispatch-callout strong{
      font-family: ${BRAND.fontHeading};
      font-size: 1.15rem;
      font-weight: 400;
    }
    .jk-dispatch-callout span,
    .jk-dispatch-callout small{ line-height: 1.45; }
    .jk-dispatch-callout small{ opacity: .68; }

    /* Key facts — the glanceable trust strip */
    .jk-facts{
      display: grid !important;
      grid-template-columns: repeat(3, 1fr);
      gap: 1px;
      list-style: none !important;
      margin: 0 0 clamp(2rem, 5vw, 3rem);
      padding: 0 !important;
      border: 1px solid currentColor;
      border-color: ${BRAND.colorBorder};
      border-radius: ${BRAND.radius};
      overflow: hidden;
      background: ${BRAND.colorBorder};
    }
    .jk-facts li{
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      padding: 1.6rem 1.4rem;
      background: ${BRAND.colorBg};
      margin: 0 !important;
    }
    .jk-facts li::before{ content: none !important; }
    .jk-facts svg{ width: 2rem; height: 2rem; flex: none; opacity: .8; margin-top: .1rem; }
    .jk-facts strong{ display: block; font-family: ${BRAND.fontHeading}; font-size: 1.2rem; font-weight: 400; line-height: 1.3; }
    .jk-facts span{ display: block; font-size: .95rem; opacity: .68; line-height: 1.4; margin-top: .3rem; }
    .jk-facts a{ font-weight: 400; color: ${BRAND.colorText}; }

    /* Rate / zone info — stacked blocks, New Zealand above International */
    .jk-cols{
      display: flex !important;
      flex-direction: column;
      gap: clamp(1.25rem, 3vw, 2rem);
      margin-bottom: clamp(2rem, 5vw, 3rem);
    }
    .jk-col{
      border: 1px solid ${BRAND.colorBorder};
      border-radius: ${BRAND.radius};
      padding: clamp(1.25rem, 3vw, 2rem);
    }
    .jk-col h2{ margin: 0 0 1rem; font-family: ${BRAND.fontHeading}; font-size: 1.5rem; font-weight: ${BRAND.fontWeightHeading}; text-transform: ${BRAND.headingTextTransform}; letter-spacing: ${BRAND.headingLetterSpacing}; }
    .jk-lead{ margin: 0 0 .7rem; font-size: 1.15rem; line-height: 1.6; }
    .jk-note{ margin: .7rem 0 0; font-size: 1rem; opacity: .68; line-height: 1.55; }

    table.jk-rates{
      width: 100%;
      border-collapse: collapse;
      font-size: 1.15rem;
    }
    table.jk-rates th, table.jk-rates td{
      text-align: left;
      padding: .85rem .4rem;
      border-bottom: 1px solid ${BRAND.colorBorder};
    }
    table.jk-rates th{
      font-family: ${BRAND.fontHeading};
      font-weight: 400;
      font-size: .8rem;
      letter-spacing: 0;
      text-transform: none;
      opacity: .75;
    }
    table.jk-rates td:not(:first-child){ font-variant-numeric: tabular-nums; }
    table.jk-rates tr:last-child td{ border-bottom: none; }

    /* Collapsed detail — kept out of the way of the glanceable summary */
    .jk-faq{ display: flex; flex-direction: column; gap: .6rem; }
    .jk-faq details{
      border: 0;
      border-bottom: 1px solid ${BRAND.colorBorder};
      border-radius: 0;
      padding: 1.15rem 1.4rem;
    }
    .jk-faq summary{
      cursor: pointer;
      font-family: ${BRAND.fontHeading};
      font-weight: 400;
      font-size: 1.1rem;
      list-style: none;
    }
    .jk-faq summary::-webkit-details-marker{ display: none; }
    .jk-faq summary::after{
      content: "+";
      float: right;
      opacity: .55;
      font-weight: 400;
    }
    .jk-faq details[open] summary::after{ content: "\\2212"; }
    .jk-faq p{ margin: .85rem 0 0; font-size: 1.05rem; line-height: 1.65; opacity: .85; max-width: 68ch; }

    @media (max-width: 860px){
      .jk-facts{ grid-template-columns: repeat(2, 1fr) !important; }
    }
    @media (max-width: 480px){
      .jk-facts{ grid-template-columns: 1fr !important; }
      table.jk-rates{ display: block; overflow-x: auto; white-space: nowrap; }
    }
  `;

  function findShippingHeading() {
    const candidates = document.querySelectorAll('h1, h2, h3, h4');
    for (const el of candidates) {
      if (/shipping options/i.test(el.textContent || '')) return el;
    }
    return null;
  }

  // Walk up from the heading to the section wrapper that actually holds the
  // FAQ copy — stop at a Shopify section/page-width/rte boundary so we leave
  // the theme's header, nav and footer completely untouched.
  function findSectionRoot(el) {
    let node = el;
    while (node && node.parentElement && node !== document.body) {
      const parent = node.parentElement;
      const cls = (parent.className || '').toString();
      if (
        parent.id === 'MainContent' ||
        /shopify-section/i.test(cls) ||
        /page-width/i.test(cls) ||
        /\brte\b/i.test(cls)
      ) {
        return parent;
      }
      node = parent;
    }
    return el.parentElement || el;
  }

  function injectStyleOnce() {
    if (document.getElementById('jk-ship-style')) return;
    const style = document.createElement('style');
    style.id = 'jk-ship-style';
    style.textContent = CONTENT_CSS;
    document.head.appendChild(style);
  }

  function render() {
    const heading = findShippingHeading();
    if (!heading) return false;

    const target = findSectionRoot(heading);
    if (!target) return false;

    injectStyleOnce();
    target.innerHTML = CONTENT_MARKUP;
    return true;
  }

  if (!render()) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (render() || attempts > 20) clearInterval(timer);
    }, 250);
  }
})();
